// Atlas geocoding (ATL-1/7). Client-side. Resolves a free-text location to a
// lat/lon via Nominatim (one polite request); the default KHFD location never
// geocodes (it uses the bundled fixture, ATL-6).
import type { LatLon } from './overpass';

/** Geocode a free-text location to lat/lon via Nominatim (ATL-1); throws on miss. */
export async function geocode(query: string, signal?: AbortSignal): Promise<LatLon> {
  const url = `https://nominatim.openstreetmap.org/search?format=json&limit=1&q=${encodeURIComponent(query)}`;
  const res = await fetch(url, { headers: { 'Accept': 'application/json' }, signal });
  if (!res.ok) throw new Error(`geocode HTTP ${res.status}`);
  const arr = (await res.json()) as Array<{ lat: string; lon: string }>;
  if (!arr.length) throw new Error(`geocode: no result for '${query}'`);
  return { lat: parseFloat(arr[0]!.lat), lon: parseFloat(arr[0]!.lon) };
}

/** Latitude/longitude bounding box (south,west,north,east) around a centre, given
 *  a side length in metres. */
export function bboxAround(center: LatLon, sideM: number): [number, number, number, number] {
  const half = sideM / 2;
  const dLat = half / 111_320;
  const dLon = half / (111_320 * Math.cos((center.lat * Math.PI) / 180));
  return [center.lat - dLat, center.lon - dLon, center.lat + dLat, center.lon + dLon];
}
